import { metricOperations } from '../../utils/percentageMetrics'
import React from 'react'
import { makeStyles } from '@material-ui/core'
import HMapLabel from '../../components/HMapLabel'
import { WSpacer } from '../../components/HMapSpacer'
import HMapTextArea from '../../components/HMapTextArea'
import HMapTextField from '../../components/HMapTextField'
import HMapColorSlider from '../../components/HMapColorSlider'
import HMapColorPicker from '../../components/HMapColorPicker'
import HMapAutoComplete from '../../components/HMapAutoComplete'
import HMapBubbleSlider from '../../components/HMapBubbleSlider'
import HMapShadowSlider from '../../components/HMapShadowSlider'
import { getOptionByValue } from '../../utils/heatmapFields'

const getMetric = (metrics, ref, key) => {
  const theMetric = metrics?.filter((metric) => metric['ref'] === ref)

  return !!theMetric?.length ? theMetric[0][key] : undefined
}

const HMapDetailsEditPanelContent = ({
  id,
  dynamicFieldsRef,
  operationsRef,
  // allMaps,
  allHeatMaps,
  onChange,
  readonly,
  formFields
}) => {
  const classes = useStyles()

  // const currentMapArray = allMaps['all'].filter((item) => item.id === id)
  // const currentMap = currentMapArray?.length && currentMapArray[0]
  // const mapMetrics = currentMap?.metrics || []
  const currentMapArray = allHeatMaps.filter((item) => item.id === id)
  const currentMap = currentMapArray?.length && currentMapArray[0]
  const mapMetrics = currentMap?.metrics || []

  const dynamicFields = dynamicFieldsRef.current
  const dynamicFieldsOptions = dynamicFields.map((field, idx) => ({
    value: field.id,
    text: field.label,
    index: idx
  }))

  const operations = operationsRef.current
  const operationsOptions = operations.map((field, idx) => ({
    value: field.value,
    text: field.text,
    index: idx
  }))

  return (
    <div className={classes.root}>
      {dynamicFields.some(field => field.config?.format === 'percentage' && ['number', 'size', 'color', 'shadow'].some(ref => formFields?.[ref + 'Field'] === field.id)) && (
        <p>Percentage fields use a fixed 0–100% scale: 60% always maps to the 60% range. Pin Value selects the cluster calculation: Average, Minimum or Maximum. Older Sum or Count settings display Average until updated.</p>
      )}
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'35%'} text="Heatmap Name" fontType="h3" />
        <HMapTextField
          width={'65%'}
          type="text"
          name="name"
          className={classes.inputField}
          placeholder=""
          value={formFields?.name}
          readonly={readonly}
          onChange={onChange}
        />
      </div>
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'35%'} text="Heatmap Description" fontType="h3" />
        <HMapTextArea
          width={'65%'}
          type="text"
          name="description"
          className={classes.inputField}
          placeholder=""
          value={formFields?.description}
          readonly={readonly}
          onChange={onChange}
        />
      </div>
      <div className={`${classes.panelRow} ${classes.borderBottom}`}>
        <HMapLabel width={'20%'} text="Pin Style" fontType="h3" />
        <HMapLabel width={'50%'} text="1.Select Pin Data" fontType="h3" />
        <HMapLabel width={'30%'} text="2.Pin Value" fontType="h3" />
      </div>
      {/* Number */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Number" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              formFields?.numberField
            )}
            // setSelectedOption={setFieldValue}
            name={'numberField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              metricOperations(operationsOptions, dynamicFields, formFields?.numberField),
              formFields?.numberCalc
            )}
            // setSelectedOption={setFieldValue}
            key={'numberCalc-' + formFields?.numberField}
            name={'numberCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.numberField)}
            readonly={readonly}
            onChange={onChange}
          />
        </div>
      </div>
      {/* Size */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Size" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              formFields?.sizeField
            )}
            // setSelectedOption={setFieldValue}
            name={'sizeField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              metricOperations(operationsOptions, dynamicFields, formFields?.sizeField),
              formFields?.sizeCalc
            )}
            // setSelectedOption={setFieldValue}
            key={'sizeCalc-' + formFields?.sizeField}
            name={'sizeCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.sizeField)}
            readonly={readonly}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapBubbleSlider
            width={'80%'}
            disabled={readonly}
            // onChange={(newValue)=> console.log(newValue)}
            defaultValues={getMetric(mapMetrics, 'size', 'ranges')}
            onChange={onChange}
            name={'sizeSlider'}
          />
        </div>
      </div>
      {/* Color */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Color" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              formFields?.colorField
            )}
            // setSelectedOption={setFieldValue}
            name={'colorField'}
            options={dynamicFieldsOptions}
            readonly={readonly}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              metricOperations(operationsOptions, dynamicFields, formFields?.colorField),
              formFields?.colorCalc
            )}
            // setSelectedOption={setFieldValue}
            key={'colorCalc-' + formFields?.colorField}
            name={'colorCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.colorField)}
            readonly={readonly}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapColorPicker
            name="colorHexes"
            colors={formFields?.colorHexes || getMetric(mapMetrics, 'color', 'color_hexes')}
            onChange={onChange}
            disabled={readonly}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapColorSlider
            width={'80%'}
            disabled={readonly}
            defaultValues={getMetric(mapMetrics, 'color', 'ranges')}
            colors={formFields?.colorHexes || getMetric(mapMetrics, 'color', 'color_hexes')}
            onChange={onChange}
            name={'colorSlider'}
          />
        </div>
      </div>
      {/* Shadow */}
      <div className={`${classes.panelMultiRow} ${classes.borderBottom}`}>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="Shadow" fontType="h3" />
          <HMapAutoComplete
            width={'45%'}
            selectedOption={getOptionByValue(
              dynamicFieldsOptions,
              formFields?.shadowField
            )}
            // setSelectedOption={setFieldValue}
            name={'shadowField'}
            options={dynamicFieldsOptions || []}
            readonly={readonly}
            onChange={onChange}
          />
          <WSpacer width={'5%'} />
          <HMapAutoComplete
            width={'30%'}
            selectedOption={getOptionByValue(
              metricOperations(operationsOptions, dynamicFields, formFields?.shadowField),
              formFields?.shadowCalc
            )}
            // setSelectedOption={setFieldValue}
            key={'shadowCalc-' + formFields?.shadowField}
            name={'shadowCalc'}
            options={metricOperations(operationsOptions, dynamicFields, formFields?.shadowField)}
            readonly={readonly}
            onChange={onChange}
          />
        </div>
        <div className={`${classes.panelRow}`}>
          <HMapLabel width={'20%'} text="" fontType="h3" />
          <HMapShadowSlider
            width={'80%'}
            disabled={readonly}
            // onChange={(newValue)=> console.log(newValue)}
            defaultValues={getMetric(mapMetrics, 'shadow', 'ranges')}
            onChange={onChange}
            name={'shadowSlider'}
          />
        </div>
      </div>
    </div>
  )
}

export default React.memo(HMapDetailsEditPanelContent)

const useStyles = makeStyles((theme) => ({
  root: {
    width: '100%',
    padding: '0px 10px',
    overflowX: 'hidden',
    overflowY: 'auto',
    '&::-webkit-scrollbar': {
      width: 5
    }
  },
  panelMultiRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    justifyContent: 'center'
  },
  panelRow: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '10px 5px'
  },
  borderBottom: {
    borderBottom: `1px solid ${theme.palette.secondary.main}`
  }
}))
